/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ChronologyEvent,
  ChronologyEventSuggestion,
  CreateChronologyEventRequest,
  DeleteChronologyEvent200,
  ForbiddenResponse,
  GenerateChronologyEvents200,
  GetChronologyEventHistory200,
  GetChronologyEvents200,
  InternalServerErrorResponse,
  NotFoundResponse,
  SuggestChronologyEventBody,
  UnauthorizedResponse,
  UpdateChronologyEventRequest
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Lists chronology events for a case, sorted by date
 */
export const getChronologyEvents = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetChronologyEvents200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events`, method: 'GET', signal
    },
      options);
    }




export const getGetChronologyEventsQueryKey = (organizationId: string,
    projectId: string,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events`
    ] as const;
    }


export const getGetChronologyEventsQueryOptions = <TData = Awaited<ReturnType<typeof getChronologyEvents>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChronologyEventsQueryKey(organizationId,projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChronologyEvents>>> = ({ signal }) => getChronologyEvents(organizationId,projectId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChronologyEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChronologyEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getChronologyEvents>>>
export type GetChronologyEventsQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetChronologyEvents<TData = Awaited<ReturnType<typeof getChronologyEvents>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChronologyEvents>>,
          TError,
          Awaited<ReturnType<typeof getChronologyEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChronologyEvents<TData = Awaited<ReturnType<typeof getChronologyEvents>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChronologyEvents>>,
          TError,
          Awaited<ReturnType<typeof getChronologyEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChronologyEvents<TData = Awaited<ReturnType<typeof getChronologyEvents>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lists chronology events for a case, sorted by date
 */

export function useGetChronologyEvents<TData = Awaited<ReturnType<typeof getChronologyEvents>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChronologyEventsQueryOptions(organizationId,projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Creates a manual chronology event
 */
export const createChronologyEvent = (
    organizationId: string,
    projectId: string,
    createChronologyEventRequest: CreateChronologyEventRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ChronologyEvent>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createChronologyEventRequest, signal
    },
      options);
    }




export const getCreateChronologyEventMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChronologyEvent>>, TError,{organizationId: string;projectId: string;data: CreateChronologyEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChronologyEvent>>, TError,{organizationId: string;projectId: string;data: CreateChronologyEventRequest}, TContext> => {

const mutationKey = ['createChronologyEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChronologyEvent>>, {organizationId: string;projectId: string;data: CreateChronologyEventRequest}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  createChronologyEvent(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateChronologyEventMutationResult = NonNullable<Awaited<ReturnType<typeof createChronologyEvent>>>
    export type CreateChronologyEventMutationBody = CreateChronologyEventRequest
    export type CreateChronologyEventMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Creates a manual chronology event
 */
export const useCreateChronologyEvent = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChronologyEvent>>, TError,{organizationId: string;projectId: string;data: CreateChronologyEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createChronologyEvent>>,
        TError,
        {organizationId: string;projectId: string;data: CreateChronologyEventRequest},
        TContext
      > => {
      return useMutation(getCreateChronologyEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Overrides fields on a chronology event
 */
export const updateChronologyEvent = (
    organizationId: string,
    projectId: string,
    eventId: string,
    updateChronologyEventRequest: UpdateChronologyEventRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ChronologyEvent>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/${eventId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateChronologyEventRequest, signal
    },
      options);
    }




export const getUpdateChronologyEventMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string;data: UpdateChronologyEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string;data: UpdateChronologyEventRequest}, TContext> => {

const mutationKey = ['updateChronologyEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChronologyEvent>>, {organizationId: string;projectId: string;eventId: string;data: UpdateChronologyEventRequest}> = (props) => {
          const {organizationId,projectId,eventId,data} = props ?? {};

          return  updateChronologyEvent(organizationId,projectId,eventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateChronologyEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateChronologyEvent>>>
    export type UpdateChronologyEventMutationBody = UpdateChronologyEventRequest
    export type UpdateChronologyEventMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Overrides fields on a chronology event
 */
export const useUpdateChronologyEvent = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string;data: UpdateChronologyEventRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateChronologyEvent>>,
        TError,
        {organizationId: string;projectId: string;eventId: string;data: UpdateChronologyEventRequest},
        TContext
      > => {
      return useMutation(getUpdateChronologyEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Soft-deletes a chronology event
 */
export const deleteChronologyEvent = (
    organizationId: string,
    projectId: string,
    eventId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<DeleteChronologyEvent200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/${eventId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteChronologyEventMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext> => {

const mutationKey = ['deleteChronologyEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChronologyEvent>>, {organizationId: string;projectId: string;eventId: string}> = (props) => {
          const {organizationId,projectId,eventId} = props ?? {};

          return  deleteChronologyEvent(organizationId,projectId,eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteChronologyEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChronologyEvent>>>

    export type DeleteChronologyEventMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Soft-deletes a chronology event
 */
export const useDeleteChronologyEvent = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteChronologyEvent>>,
        TError,
        {organizationId: string;projectId: string;eventId: string},
        TContext
      > => {
      return useMutation(getDeleteChronologyEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Extracts chronology events from existing structured data without reprocessing documents
 */
export const generateChronologyEvents = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GenerateChronologyEvents200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/generate`, method: 'POST', signal
    },
      options);
    }




export const getGenerateChronologyEventsMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateChronologyEvents>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateChronologyEvents>>, TError,{organizationId: string;projectId: string}, TContext> => {

const mutationKey = ['generateChronologyEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateChronologyEvents>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  generateChronologyEvents(organizationId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateChronologyEventsMutationResult = NonNullable<Awaited<ReturnType<typeof generateChronologyEvents>>>

    export type GenerateChronologyEventsMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Extracts chronology events from existing structured data without reprocessing documents
 */
export const useGenerateChronologyEvents = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateChronologyEvents>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateChronologyEvents>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {
      return useMutation(getGenerateChronologyEventsMutationOptions(options), queryClient);
    }
    /**
 * @summary Uses AI to extract chronology event fields from a page's content
 */
export const suggestChronologyEvent = (
    organizationId: string,
    projectId: string,
    suggestChronologyEventBody: SuggestChronologyEventBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ChronologyEventSuggestion>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/suggest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: suggestChronologyEventBody, signal
    },
      options);
    }




export const getSuggestChronologyEventMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestChronologyEvent>>, TError,{organizationId: string;projectId: string;data: SuggestChronologyEventBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestChronologyEvent>>, TError,{organizationId: string;projectId: string;data: SuggestChronologyEventBody}, TContext> => {

const mutationKey = ['suggestChronologyEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestChronologyEvent>>, {organizationId: string;projectId: string;data: SuggestChronologyEventBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  suggestChronologyEvent(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuggestChronologyEventMutationResult = NonNullable<Awaited<ReturnType<typeof suggestChronologyEvent>>>
    export type SuggestChronologyEventMutationBody = SuggestChronologyEventBody
    export type SuggestChronologyEventMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Uses AI to extract chronology event fields from a page's content
 */
export const useSuggestChronologyEvent = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestChronologyEvent>>, TError,{organizationId: string;projectId: string;data: SuggestChronologyEventBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof suggestChronologyEvent>>,
        TError,
        {organizationId: string;projectId: string;data: SuggestChronologyEventBody},
        TContext
      > => {
      return useMutation(getSuggestChronologyEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Clears manual overrides on an extracted chronology event
 */
export const resetChronologyEvent = (
    organizationId: string,
    projectId: string,
    eventId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ChronologyEvent>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/${eventId}/reset`, method: 'POST', signal
    },
      options);
    }




export const getResetChronologyEventMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext> => {

const mutationKey = ['resetChronologyEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetChronologyEvent>>, {organizationId: string;projectId: string;eventId: string}> = (props) => {
          const {organizationId,projectId,eventId} = props ?? {};

          return  resetChronologyEvent(organizationId,projectId,eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetChronologyEventMutationResult = NonNullable<Awaited<ReturnType<typeof resetChronologyEvent>>>

    export type ResetChronologyEventMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Clears manual overrides on an extracted chronology event
 */
export const useResetChronologyEvent = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetChronologyEvent>>,
        TError,
        {organizationId: string;projectId: string;eventId: string},
        TContext
      > => {
      return useMutation(getResetChronologyEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Marks a chronology event as confirmed
 */
export const confirmChronologyEvent = (
    organizationId: string,
    projectId: string,
    eventId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ChronologyEvent>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/${eventId}/confirm`, method: 'POST', signal
    },
      options);
    }




export const getConfirmChronologyEventMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext> => {

const mutationKey = ['confirmChronologyEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmChronologyEvent>>, {organizationId: string;projectId: string;eventId: string}> = (props) => {
          const {organizationId,projectId,eventId} = props ?? {};

          return  confirmChronologyEvent(organizationId,projectId,eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmChronologyEventMutationResult = NonNullable<Awaited<ReturnType<typeof confirmChronologyEvent>>>

    export type ConfirmChronologyEventMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Marks a chronology event as confirmed
 */
export const useConfirmChronologyEvent = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmChronologyEvent>>, TError,{organizationId: string;projectId: string;eventId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmChronologyEvent>>,
        TError,
        {organizationId: string;projectId: string;eventId: string},
        TContext
      > => {
      return useMutation(getConfirmChronologyEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieves the revision history of a chronology event
 */
export const getChronologyEventHistory = (
    organizationId: string,
    projectId: string,
    eventId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetChronologyEventHistory200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/${eventId}/history`, method: 'GET', signal
    },
      options);
    }




export const getGetChronologyEventHistoryQueryKey = (organizationId: string,
    projectId: string,
    eventId: string,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/projects/${projectId}/chronology-events/${eventId}/history`
    ] as const;
    }


export const getGetChronologyEventHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getChronologyEventHistory>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEventHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChronologyEventHistoryQueryKey(organizationId,projectId,eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChronologyEventHistory>>> = ({ signal }) => getChronologyEventHistory(organizationId,projectId,eventId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined && eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChronologyEventHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChronologyEventHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getChronologyEventHistory>>>
export type GetChronologyEventHistoryQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetChronologyEventHistory<TData = Awaited<ReturnType<typeof getChronologyEventHistory>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    eventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEventHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChronologyEventHistory>>,
          TError,
          Awaited<ReturnType<typeof getChronologyEventHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChronologyEventHistory<TData = Awaited<ReturnType<typeof getChronologyEventHistory>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEventHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChronologyEventHistory>>,
          TError,
          Awaited<ReturnType<typeof getChronologyEventHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChronologyEventHistory<TData = Awaited<ReturnType<typeof getChronologyEventHistory>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEventHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the revision history of a chronology event
 */

export function useGetChronologyEventHistory<TData = Awaited<ReturnType<typeof getChronologyEventHistory>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    eventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChronologyEventHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChronologyEventHistoryQueryOptions(organizationId,projectId,eventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






